import { useState } from "react";
import { MapPin, Search, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useApi, errMsg } from "@/lib/api";

export const LocationSearch = ({ q, update }) => {
  const api = useApi();
  const [results, setResults] = useState([]);
  const [busy, setBusy] = useState(false);

  const search = async () => {
    if ((q.location || "").trim().length < 3) return;
    setBusy(true);
    try {
      const r = await api.get("/geo/search", { params: { q: q.location } });
      setResults(r.data);
      if (!r.data.length) toast.info("Nessun luogo trovato: prova a scrivere anche la città");
    } catch (e) { toast.error(errMsg(e, "Ricerca non riuscita")); }
    finally { setBusy(false); }
  };

  const pick = async (p) => {
    setResults([]);
    update({ location: p.label, location_lat: p.lat, location_lon: p.lon });
    try {
      const r = await api.get("/geo/distance", { params: { lat: p.lat, lon: p.lon } });
      update({ distance_km: r.data.km });
      toast.success(`Distanza dalla sede: ${r.data.km} km (solo andata)`);
    } catch (e) { toast.error(errMsg(e, "Calcolo km non riuscito: inseriscili a mano")); }
  };

  return (
    <div className="relative">
      <div className="flex gap-2">
        <div className="relative flex-1">
          <MapPin className={`absolute left-2.5 top-2.5 h-4 w-4 ${q.location_lat != null ? "text-sky-400" : "text-slate-500"}`} />
          <Input value={q.location} className="pl-8"
            onChange={(e) => update({ location: e.target.value, location_lat: null, location_lon: null })}
            onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); search(); } }}
            placeholder="Hotel, indirizzo, città" data-testid="quote-location-input" />
        </div>
        <Button type="button" variant="secondary" onClick={search} disabled={busy} data-testid="quote-location-search-btn">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Search className="h-4 w-4" />}<span className="ml-1 hidden sm:inline">Trova sulla mappa</span>
        </Button>
      </div>
      {results.length > 0 && (
        <ul className="absolute z-30 mt-1 w-full rounded-md border border-slate-700 bg-slate-900 shadow-xl max-h-64 overflow-auto" data-testid="quote-location-results">
          {results.map((p, i) => (
            <li key={i}>
              <button type="button" onClick={() => pick(p)} className="w-full text-left px-3 py-2 text-sm hover:bg-slate-800" data-testid={`quote-location-result-${i}`}>{p.label}</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
